const names = [
  'DL01AB1234',
  'KA05ZY9876',
  'MH02MN5566',
  'GJ08KL3344',
  'DL04CD9988',
  'UP12EF7711',
  'HR06GH2233',
  'WB01IJ0099',
  'KA09JK8844',
  'TN07LM1122',
  'RJ14NO4455',
  'MH10PQ9900',
  'DL03QR2288',
  'GJ05ST7733',
  'UP16UV6644',
  'HR02WX3311',
  'WB08YZ0077',
  'KA02AB9922',
  'TN10CD5588',
  'RJ06EF1144',
  'MH01GH7799',
  'DL09IJ3322',
  'GJ03KL0066',
  'UP07MN8811',
  'HR11OP4477',
  'WB04QR9933',
  'KA08ST2200',
  'TN01UV7755',
  'RJ10WX1199',
  'MH05YZ5522',
  'DL02AB6688',
  'GJ09CD1133',
  'UP03EF8855',
  'HR15GH0022',
  'WB06IJ6699',
  'KA04KL3377',
  'TN08MN0044',
  'RJ01OP7711',
  'MH03QR4488',
  'DL12ST0066',
  'GJ07UV3399',
  'UP10WX8822',
  'HR08YZ5500',
  'WB03AB2277',
  'KA06CD9911',
  'TN04EF4466',
  'RJ08GH1133',
  'MH07IJ7788',
  'DL06KL2255',
  'GJ11MN0099',
  'UP04OP6622',
  'HR01QR1177',
  'WB09ST4400',
  'KA01UV9966',
  'TN06WX2244',
  'RJ04YZ7711',
  'MH08AB3399',
  'DL05CD0055',
  'GJ02EF6611',
  'UP08GH4488',
  'HR10IJ1133',
  'WB07KL7700',
  'KA07MN3366',
  'TN02OP9944',
  'RJ09QR5522',
  'MH04ST1177',
  'DL08UV8833',
  'GJ12WX0055',
  'UP01YZ6699',
  'HR04AB2200',
  'WB02CD8866',
  'KA03EF4422',
  'TN09GH0088',
  'RJ02IJ5511',
  'MH09KL9977',
  'DL07MN3344',
  'GJ04OP0077',
  'UP06QR7711',
  'HR12ST3388',
  'WB05UV0066',
  'KA10WX5522',
  'TN03YZ1199',
  'RJ07AB6633',
  'MH06CD2200',
  'DL11EF8844',
  'GJ06GH4411',
  'UP02IJ0077',
  'HR09KL6633',
  'WB01MN9900',
  'KA01OP3355',
  'TN05QR8822',
  'RJ03ST1166',
  'MH02UV5500',
  'DL01WX9933',
  'GJ08YZ3377',
  'UP09AB0044',
  'HR07CD7711',
  'WB04EF3399',
  'KA08GH0066',
  'TN11IJ5522',
];

export default names;
